<template>
  <div class="funds-flow">
    <div class="title" @click="showAlert">
      {{ $t('quote.brief.funds-flow') }}
    </div>
    <div class="line-chart">
      <svg
        v-show="tradingData && tradingData.length > 0"
        ref="svg"
        preserveAspectRatio="none"
      />
    </div>
  </div>
</template>
<script>
import Chart from './chart'
import Stock from 'utils/stock'
import Icon from 'com/Icon'
import Modal from 'com/Modal'
import { TIMER_EXPRESSION } from 'const/common'
import { mapGetters } from 'vuex'
import themeMixin from './theme-mixin'
import { MARKET_TYPE } from 'const/stock'
import bus from 'src/eventbus'

const FUNDS_FLOW_TIMER_NAME = 'funds flow refresh'

export default {
  name: 'FundsChangeCard',
  props: {
    stock: {
      required: true
    },
    isTradePanel: false
  },
  components: { Chart, Icon },
  mixins: [themeMixin],
  data() {
    return {
      tradingData: []
    }
  },
  computed: {
    ...mapGetters(['hkMarketOpen', 'cnMarketOpen', 'usMarketOpen']),
    api() {
      if (this.stock) {
        return Stock.getStock(this.stock.market, this.stock.symbol)
      }
    },
    market() {
      return this.stock.market
    },
    isShowHKTimer() {
      return this.hkMarketOpen && this.market === MARKET_TYPE.HK
    },
    isShowUSTimer() {
      return this.usMarketOpen && this.market === MARKET_TYPE.US
    }
  },
  watch: {
    'stock.symbol'() {
      this.loadData()
    },
    hkMarketOpen(open) {
      this.changeTimer(open, MARKET_TYPE.HK)
    },
    usMarketOpen(open) {
      this.changeTimer(open, MARKET_TYPE.US)
    },
    theme() {
      this.draw()
    }
  },
  mounted() {
    bus.on(bus.$events.DOCUMENT_VISIBLE_CHANGE, this.changeTab)
    this.loadData()
    this.timer = this.$cron(TIMER_EXPRESSION.FUNDS_FLOW).interval(
      FUNDS_FLOW_TIMER_NAME,
      this.loadData
    )
    if (!this.isShowHKTimer && !this.isShowUSTimer) {
      this.timer.pause()
    }
  },
  destroyed() {
    this.$cron.clear(FUNDS_FLOW_TIMER_NAME)
    bus.off(bus.$events.DOCUMENT_VISIBLE_CHANGE, this.changeTab)
  },
  methods: {
    changeTab({ visible }) {
      if (visible) {
        if (this.timer) {
          this.loadData()
        }
      }
    },
    changeTimer(open, market) {
      if (!this.timer || this.market !== market) return
      if (open) {
        this.timer.resume()
      } else {
        this.timer.pause()
      }
    },
    draw() {
      if (!this.$refs.svg) return
      this.chart = new Chart(
        this.$refs.svg,
        this.curTheme[this.theme].activeColor
      )
      this.chart.render(this.tradingData, this.market)
    },
    loadData() {
      if (typeof this.api.getFundsFlowTrend !== 'function') {
        return false
      }
      this.api.getFundsFlowTrend(-1, this.stock.symbol).then(data => {
        if (data && data.items) {
          this.tradingData = data.items
          this.draw()
        } else {
          this.tradingData = []
        }
      })
    },
    showAlert() {
      Modal.open({
        title: this.$t('quote.brief.funds-flow'),
        content: this.$t('quote.brief.funds-change-intro'),
        cancelButton: false,
        style: { textAlign: 'left' }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.funds-flow {
  .title {
    color: var(--default-font-color);
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    span {
      height: 14px;
      width: 14px;
      margin-left: 5px;
      .icon {
        width: 100%;
        height: 100%;
        vertical-align: 4px;
      }
    }
  }
  .line-chart {
    margin: 0 auto;
    width: 280px;
    height: 230px;
  }
}
</style>
<style lang="less">
.funds-flow svg {
  .grid,
  .x-axis {
    path {
      stroke: var(--light-grey);
      stroke-opacity: 0.5;
      shape-rendering: crispEdges;
    }
    line {
      stroke: var(--light-grey);
      stroke-opacity: 0.5;
      shape-rendering: crispEdges;
    }
    text {
      font-size: 12px;
    }
    .tick:last-child text {
      text-anchor: end;
    }
  }
  .grid {
    text {
      fill: #838d9e;
    }
  }
  .x-axis {
    text {
      fill: var(--default-font-color);
    }
  }
}
</style>
